export function SectionHeader({ eyebrow, title, subtitle, align = "left", id }) {
  return (
    <header className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`} id={id}>
      {eyebrow && <p className="eyebrow mb-4">{eyebrow}</p>}
      <h2 className="h-editorial text-foreground">{title}</h2>
      {subtitle && <p className="mt-5 text-base md:text-lg text-muted-foreground leading-relaxed">{subtitle}</p>}
    </header>
  );
}

export function StatBlock({ label, value, sub }) {
  return (
    <div className="card-surface">
      <p className="eyebrow">{label}</p>
      <p className="mt-3 text-h2">{value}</p>
      {sub && <p className="mt-2 text-sm text-muted-foreground">{sub}</p>}
    </div>
  );
}

export function Marquee({ items }) {
  // Backward-compatible string marquee
  const doubled = [...items, ...items];
  return (
    <div className="overflow-hidden border-y border-border/60 bg-card/30 py-5">
      <div className="marquee-track flex w-max gap-12 whitespace-nowrap">
        {doubled.map((it, idx) => (
          <span key={`${it}-${idx}`} className="inline-flex items-center gap-3 font-display text-xl md:text-2xl tracking-tight">
            <span className="inline-block h-1.5 w-1.5 rounded-full bg-signal-lime" />
            {it}
          </span>
        ))}
      </div>
    </div>
  );
}

/** Stock-ticker style: continuous seamless scroll with icon + label + delta-ish meta. */
export function Ticker({ items }) {
  // Duplicate the array so the loop is visually seamless when -100% wraps
  const doubled = [...items, ...items];
  return (
    <div className="ticker border-y border-border/60 bg-card/40 py-4" data-testid="home-ticker">
      <div className="ticker-track">
        {doubled.map((it, idx) => {
          const Icon = it.icon;
          return (
            <div key={`${it.from}-${it.to}-${idx}`} className="inline-flex items-center gap-3 whitespace-nowrap shrink-0">
              <span className="inline-flex h-8 w-8 items-center justify-center rounded-full border border-signal-lime/40 bg-signal-lime/10 text-signal-lime">
                {Icon && <Icon size={15} strokeWidth={2} />}
              </span>
              <span className="font-display text-base md:text-lg tracking-tight">{it.from}</span>
              <span className="font-mono text-[11px] uppercase tracking-[0.22em] text-signal-lime">→</span>
              <span className="font-display text-base md:text-lg tracking-tight">{it.to}</span>
              <span className="font-mono text-[10px] uppercase tracking-[0.18em] text-muted-foreground border border-border/60 rounded-full px-2 py-0.5">
                {it.tag}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
